export enum VildEncodingStatusType {
  CORRECT = 'correct',
  ERROR = 'error',
  MANUAL = 'manual',
  AREA = 'area'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/vildencodingstatustype.ts